import styled from 'styled-components';
import { Colors } from '../constants/colors';
import { Fonts } from '../constants/fonts';
import { Device } from '../constants/device';

type ToggleButtonProps = {
  active: boolean;
}

export const ToggleButton = styled.button<ToggleButtonProps>`
  color: ${Colors.textColor};
  border: 1px solid ${Colors.borderColor};
  background: ${Colors.white};
  font-weight: ${props => props.active ? 700 : 400};
  z-index: ${props => props.active ? 2 : 1};
  font-family: ${Fonts.base};
  font-size: 16px;
  line-height: 1.2;
  flex: 1;
  display: flex;
  align-items: center;
  text-align: left;
  white-space: pre;
  padding: 15px 20px;
  transition: background-color 0.2s ease-in-out;

  ${Device.downLaptop} {
    min-width: 50%;
    height: auto;
    white-space: break-spaces;
  }

  &[disabled] {
    color: ${Colors.grey};
  }

  :hover {
    background: ${Colors.white};
  }
`;
